/**
 * Basic popup methods
 *
 * @props
 * id: String
 */
import CommMixin from "./CommMixin";
var PopupMixin = {
  mixins: [CommMixin],
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data: function () {
    return {
      active: false,
      onScreen: false,
    };
  },
  mounted: function () {
    this.initEvents();
  },
  methods: {
    initEvents: function () {
      this.subscribe("rb-open-popup", this.onOpenPopup);
    },
    onOpenPopup: function (data) {
      if (data.id === this.id) {
        this.open();
        this.broadcast("rb-notify-open-popup", { id: data.id });
      }
    },
    open: function () {
      this.active = true;
      setTimeout(() => {
        this.onScreen = true;
      }, 200);
    },
    close: function () {
      this.onScreen = false;
      setTimeout(() => {
        this.active = false;
      }, 200);
      this.broadcast("rb-notify-close-popup", { id: this.id });
    },
  },
};
export default PopupMixin;
